import React from "react";

const PrivacyPolicy = () => {
  return (
    <div>
      <h2>Privacy Policy</h2>
      <p>
        This app is provided by RedLines at no cost and is intended for use in
        its current state. This Privacy Policy aims to inform visitors about our
        practices concerning the collection, use, and disclosure of personal
        information for users of our Service.
      </p>
      <h4>Information Collection and Use</h4>
      <p>
        The Redlines app does not collect, use, or share any personal or
        sensitive user data.
      </p>
      <h4>Security</h4>
      <p>
        We highly value your trust in using our app. While we do not collect any
        user data, we still implement appropriate measures to secure and protect
        the integrity of our service.
      </p>
      <h4>External Links</h4>
      <p>
        Our app may include links to external websites or services, such as
        donation pages or third-party content. These sites are not operated by
        us, and we encourage you to review their respective privacy policies.
        RedLines is not responsible for the content, privacy policies, or
        practices of any third-party websites or services.
      </p>

      <h4>Changes to This Privacy Policy</h4>
      <p>
        This Privacy Policy may be updated periodically. We advise you to review
        this page regularly for any changes. Any updates will be posted here and
        will take effect immediately upon being published.
      </p>

      <h4>Contact Us</h4>
      <p>
        If you have any questions or suggestions regarding our Privacy Policy,
        feel free to contact us:
      </p>
      <p>
        <span>Email:</span>{" "}
        <a href="mailto:info@redlines.news">info@redlines.news</a>
      </p>
      <p>
        <span>Website:</span>{" "}
        <a href="https://redlines.news">https://redlines.news</a>
      </p>
    </div>
  );
};

export default PrivacyPolicy;
